"use client";

import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/utils";

/**
 * Progress — adopted from shadcn (Radix Progress), consuming @basis/tokens semantic tokens.
 *
 * basis extension: pass `value={null}` (or omit `value`) for an INDETERMINATE bar (unknown-duration
 * work, e.g. knowledge-graph processing). Radix sets `data-state="indeterminate"`, which drives a
 * token-only pulsing indicator. Determinate usage takes a 0–100 `value`.
 */
function Progress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  const indeterminate = value == null;
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={value}
      className={cn(
        "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "bg-primary h-full w-full flex-1 transition-all",
          indeterminate && "animate-pulse",
        )}
        style={indeterminate ? undefined : { transform: `translateX(-${100 - (value ?? 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
